<template>
  <v-app id="hser">
    <v-main>
      <v-container fluid>
      <v-row>
          <v-col cols="2">
            <v-select v-model="bedrCodesSelected" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Company" multiple></v-select>
          </v-col>
          <v-col cols="5">
            <v-select v-model="statCodesSelected" :items="statCodes" item-value="statCode"  item-text="statCode" label="Status" multiple></v-select>
          </v-col>
          <v-col cols="2">
            <v-select v-model="realtestCodesSelected" :items="realtestCodes" item-value="realtestCode"  item-text="realtestCode" label="Real / Test" multiple></v-select>
          </v-col>
          <v-col cols="1">
            <v-btn class="primary ma-0" small @click="ovrz">Create excel</v-btn>
          </v-col> 
      </v-row>

    </v-container>
    </v-main>
    <navBar title="Ares - Main menu" :home="true" :accolist="true" type="main"/>
  </v-app>
</template>

<script>
 import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  data() {
    return {
      statCodesSelected: [],
      statCodes: [],
      bedrCodesSelected: [],
      bedrCodes: [],
      realtestCodesSelected: [],
      realtestCodes: [],
      items: [],
      param: {}
    }
  },
  created() {
    var deze = this;
      this.$axios
      .post("ares/json/ares/huis/ovrz/getHserParam.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHserParam"
        },
        getHserParam: {}
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.param = res.data.getHserParam;
           res.data.getHserParam.statKeuzes.forEach(function(accoStat) {
           deze.statCodes.push(accoStat.statCode);
            if (accoStat.statSelected === true) {
               deze.statCodesSelected.push(accoStat.statCode);
            } 
           });
           res.data.getHserParam.bedrKeuzes.forEach(function(bedr) {
             deze.bedrCodes.push(bedr.bedrCode);
             if (bedr.bedrSelected === true) {
                deze.bedrCodesSelected.push(bedr.bedrCode);
             }
           });
           res.data.getHserParam.realtestKeuzes.forEach(function(rt) {
             deze.realtestCodes.push(rt.realtestCode);
             if (rt.realtestSelected === true) {
                deze.realtestCodesSelected.push(rt.realtestCode);
             }
           });
        }
      });

  },
  methods: {
     ovrz() {
      this.results = true;
      this.$axios
        .post("ares/json/ares/huis/ovrz/excelExportHser.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "excelExportHser"
          },
          excelExportHser: {
            stat_codes: this.statCodesSelected,
            bedr_codes: this.bedrCodesSelected,
            realtest_codes: this.realtestCodesSelected
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.excelExportHser;
            window.open(this.items.filename,'_blank');
            /*
            if (res.data.color == "warning") {
                 this.$store.dispatch('setSnackbar', {
                  showing: true,
                  text: res.data.text,
                  color: res.data.color
                 });
            }
            */
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
